export const applicationConfig = {
  serviceName: 'タイミー管理画面',
  productionHostName: 'app-new.taimee.co.jp',
} as const;
